{
  "name": "shoukaku",
  "version": "4.0.1",
  "description": "A stable and updated wrapper around Lavalink",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "scripts": {
    "build": "npm run build:ts && npm run build:docs",
    "build:ts": "tsup --config tsup-config.json",
    "build:docs": "typedoc --theme default --readme README.md --out docs/ --entryPointStrategy expand src/.",
    "lint": "eslint --fix --ext .ts",
    "prepare": "npm run build:ts"
  },
  "keywords": [
    "bot",
    "music",
    "lavalink",
    "api",
    "discord",
    "lavalink.js",
    "discord.js",
    "lavalink-api",
    "weeb-library"
  ],
  "engines": {
    "node": ">=18.0.0",
    "npm": ">=7.0.0"
  },
  "author": "Saya",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/shipgirlproject/Shoukaku.git"
  },
  "dependencies": {
    "ws": "^8.14.2"
  },
  "devDependencies": {
    "@augu/eslint-config": "^5.0.0",
    "@types/node": "^20.10.5",
    "@types/node-fetch": "^2.6.9",
    "@types/ws": "^8.5.10",
    "@typescript-eslint/eslint-plugin": "^6.15.0",
    "@typescript-eslint/parser": "^6.15.0",
    "eslint": "^8.56.0",
    "tsup": "^8.0.1",
    "typedoc": "^0.25.4",
    "typescript": "^5.3.3"
  }
}
